import { createAsyncThunk } from '@reduxjs/toolkit';
import { BundleCategory } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { FindBundleCategory, GetBundleCategory } from '../../bundleCategory/api/interface';

export const findSelectBundleCategory = createAsyncThunk(
  'selectBundleCategory/findSelectBundleCategory',
  async (values: FindBundleCategory, { rejectWithValue }) => {
    try {
      const response = await BundleCategory.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const searchSelectBundleCategory = createAsyncThunk(
  'selectBundleCategory/searchSelectBundleCategory',
  async (values: FindBundleCategory, { rejectWithValue }) => {
    try {
      const response = await BundleCategory.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getSelectBundleCategory = createAsyncThunk(
  'selectBundleCategory/getSelectBundleCategory',
  async ({ id }: GetBundleCategory, { rejectWithValue }) => {
    try {
      const response = await BundleCategory.get(id, {});
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
